import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { RequestManagementService, } from '../services/request-management.service';
import { UserService } from '../services/user.service';
import 'rxjs/add/operator/map';
import { BankModel, ServiceTypeModel, ServiceTypePermissionModel} from '../_models/_index';

@Injectable()
export class InfraService {

    constructor(private requestManagement: RequestManagementService,
        private userService: UserService) {
    }

    public getBanks(): Promise<BankModel[]> {
        return this.requestManagement.callGetRequest('infra/getBanks', null).map((response: Response) => {
            return <BankModel[]>response.json();
        }).toPromise();
    }

    public getServiceType(): Promise<ServiceTypeModel[]> {
        return this.requestManagement.callGetRequest('infra/getServiceType', { 'userId': this.userService.getCurrentUser().id }).map((response: Response) => {
            return <ServiceTypeModel[]>response.json();
        }).toPromise();
    }

    public getServiceTypePermission(): Promise<ServiceTypePermissionModel[]> {
        return this.requestManagement.callGetRequest('infra/getServiceTypePermission', null).map((response: Response) => {
            return <ServiceTypePermissionModel[]>response.json();
        }).toPromise();
    }

}



// WEBPACK FOOTER //
// ./src/app/services/infra.service.ts